import { Pipe, PipeTransform } from '@angular/core';
import { NumberOptions, NumberService } from 'services/number.service';

@Pipe({
	name: 'currency'
})

export class CurrencyPipe implements PipeTransform {
	
	constructor(private readonly numberService: NumberService) { }

	transform(value: number | undefined, options: NumberOptions = new NumberOptions): string {
		if (value === undefined) return '';
		return this.numberService.formatNumber(value, 2, options);
	}
}
